import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import PesqReducer from './PesqReducer';
import DadosReducer from './DadosReducer';
import TemaReducer from './TemaReducer';
import AuditoriaReducer from './AuditoriaReducer';
import ValidacaoReducer from './ValidacaoReducer';
import ConnectionReducer from './ConnectionReducer';
import DevConfigReducer from './DevConfigReducer';
import StatusServidorReducer from './StatusServidorReducer';
import AtualizacaoReducer from './AtualizacaoReducer';

export default combineReducers({
    auth: AuthReducer,
    pesq: PesqReducer,
    dados: DadosReducer,
    connection: ConnectionReducer,
    statusServidor: StatusServidorReducer,
    tema: TemaReducer,
    auditoria: AuditoriaReducer,
    validacao: ValidacaoReducer,
    devConfig: DevConfigReducer,
    atualizacao: AtualizacaoReducer
});
